import {Shipment} from '../models/shipment';
import {TrackTrace} from '../models/trackTrace';
import {TranslationFunctions} from '../i18n/i18n-types';
import {
    PackingSlipState,
    TrackTraceStatus,
} from '../types/packingSlipStatusResponse';

const getTrackingInformation = (
    shipment: Shipment,
    trackTrace: TrackTrace | null,
    LL: TranslationFunctions
): [string, string] => {
    if (trackTrace === null) {
        switch (true) {
            case shipment.state === PackingSlipState.PENDING_BACKORDER:
                return [
                    LL.shipment.track.state.title.BACKORDER(),
                    LL.shipment.track.state.description.BACKORDER(),
                ];
            case shipment.state === PackingSlipState.SHIPPED &&
                shipment.isDelayed:
                return [
                    LL.shipment.track.state.title.SHIPPED_DELAYED(),
                    LL.shipment.track.state.description.SHIPPED_DELAYED(),
                ];
            case shipment.state === PackingSlipState.SHIPPED:
                return [
                    LL.shipment.track.state.title.SHIPPED(),
                    LL.shipment.track.state.description.SHIPPED(),
                ];
        }

        return [
            LL.shipment.track.state.title.PROCESSING(),
            LL.shipment.track.state.description.PROCESSING(),
        ];
    }

    switch (true) {
        // shipped
        case [TrackTraceStatus.PACKED, TrackTraceStatus.SHIPPED].includes(
            trackTrace.status
        ) && shipment.isDelayed:
            return [
                LL.shipment.track.state.title.SHIPPED_DELAYED(),
                LL.shipment.track.state.description.SHIPPED_DELAYED(),
            ];
        case [TrackTraceStatus.PACKED, TrackTraceStatus.SHIPPED].includes(
            trackTrace.status
        ):
            return [
                LL.shipment.track.state.title.SHIPPED_DELAYED(),
                LL.shipment.track.state.description.SHIPPED_DELAYED(),
            ];
        // in transit
        case trackTrace.status === TrackTraceStatus.IN_SORTING:
            return [
                LL.shipment.track.state.title.IN_SORTING(),
                LL.shipment.track.state.description.IN_SORTING(),
            ];
        case trackTrace.status === TrackTraceStatus.IN_TRANSIT:
            return [
                LL.shipment.track.state.title.IN_TRANSIT(),
                LL.shipment.track.state.description.IN_TRANSIT(),
            ];
        case trackTrace.status === TrackTraceStatus.ATTEMPT_DELAYED:
            return [
                LL.shipment.track.state.title.ATTEMPT_DELAYED(),
                LL.shipment.track.state.description.ATTEMPT_DELAYED(),
            ];
        case trackTrace.status === TrackTraceStatus.ATTEMPT_NOT_AT_HOME:
            return [
                LL.shipment.track.state.title.ATTEMPT_NOT_AT_HOME(),
                LL.shipment.track.state.description.ATTEMPT_NOT_AT_HOME(),
            ];
        // delivered
        case trackTrace.status === TrackTraceStatus.AT_PICKUP_POINT:
            return [
                LL.shipment.track.state.title.AT_PICKUP_POINT(),
                LL.shipment.track.state.description.AT_PICKUP_POINT(),
            ];
        case trackTrace.status === TrackTraceStatus.COLLECTED_AT_PICKUP_POINT:
            return [
                LL.shipment.track.state.title.COLLECTED_AT_PICKUP_POINT(),
                LL.shipment.track.state.description.COLLECTED_AT_PICKUP_POINT(),
            ];
        case trackTrace.status === TrackTraceStatus.DELIVERED_AT_NEIGHBOURS:
            return [
                LL.shipment.track.state.title.DELIVERED_AT_NEIGHBOURS(),
                LL.shipment.track.state.description.DELIVERED_AT_NEIGHBOURS(),
            ];
        case trackTrace.status === TrackTraceStatus.DELIVERED:
            return [
                LL.shipment.track.state.title.DELIVERED(),
                LL.shipment.track.state.description.DELIVERED(),
            ];
        // faulty
        case trackTrace.status === TrackTraceStatus.DAMAGED:
            return [
                LL.shipment.track.state.title.DAMAGED(),
                LL.shipment.track.state.description.DAMAGED(),
            ];
        case trackTrace.status === TrackTraceStatus.RETURNED:
            return [
                LL.shipment.track.state.title.RETURNED(),
                LL.shipment.track.state.description.RETURNED(),
            ];
        case trackTrace.status === TrackTraceStatus.REFUSED:
            return [
                LL.shipment.track.state.title.REFUSED(),
                LL.shipment.track.state.description.REFUSED(),
            ];
        case [
            TrackTraceStatus.ERROR,
            TrackTraceStatus.FAILED,
            TrackTraceStatus.OTHER,
        ].includes(trackTrace.status):
            return [
                LL.shipment.track.state.title.FAULTY(),
                LL.shipment.track.state.description.FAULTY(),
            ];
    }

    return ['', ''];
};

export default getTrackingInformation;
